module.exports = __webpack_public_path__ + "img/NicheColor.90b0f391.png";